<mat-card class="card-section">
    <mat-card-title>Enterprise Technology Feedback Form</mat-card-title>
    <mat-card-subtitle>This form is to collect feedback for work requests completed by Supply Ontario's internal
        Enterprise Technology team. </mat-card-subtitle>
    <mat-card-content>
        <mat-card-actions *ngIf="screenMode !== 'Entry'" class="button-bar2">
        <button (click)="goBack()" type="button" mat-raised-button ><mat-icon
            class="mat-18 go-back">arrow_back_ios</mat-icon> Go Back </button>
            </mat-card-actions>
        <form id="feedback-form-header" class="feedback-form-header" [formGroup]="workRequestForm" #wrForm="ngForm">
            <div class="row">
                <div class="col-sm-12">
                    <div class="wrLabel" >
                        <mat-label>{{workRequest.requestType}}: {{workRequest.wrNumber}}  ({{workRequest.subject}})</mat-label>
                    </div>
                </div>
            </div>
                       
            <div class="row">
                <div class="col-sm-12">
                    <div class="wrLabel">
                        <mat-label>Description / Issue / Business Requirements: </mat-label>
                    </div>
                    <div  class="wrData">{{workRequest.businessRequirements}}</div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="wrLabel">
                        <mat-label>Resolution: </mat-label>
                    </div>
                    <div  class="wrData">{{workRequest.resolution || "No resolution entered."}}</div>
                </div>
            </div>
            <!--
            <div class="row">
                <div class="col-sm-12">
                    <so-input [formCtrl]="workRequestForm.controls['subject'] | formControl"
                        placeHolder="Enter a subject for the request." label="Subject" [readOnlyInd]="true"
                        [disableClearBtn]="true">
                    </so-input>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <so-textarea [formCtrl]="workRequestForm.controls['businessRequirements'] | formControl"
                        [readOnlyInd]="true" placeHolder="Please enter description / issue / business requirements."
                        label="Description / Issue / Business Requirements"
                        errormessage="Description / Issue / Business Requirements should be at least 30 characters."
                        [disableClearBtn]="true"></so-textarea>

                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <so-textarea [formCtrl]="workRequestForm.controls['resolution'] | formControl" [readOnlyInd]="true"
                        placeHolder="Please enter a resolution." label="Resolution"
                        errormessage="Resolution is required when closing a work order or consultation."
                        [disableClearBtn]="true"></so-textarea>

                </div>
            </div>
            -->
        </form>

        <br>
      
            <form id="feedback-form" class="feedback-form" [formGroup]="feedbackForm" #fbForm="ngForm">
                <div class="row">
                    <div class="col-sm-12">
                        <span class="rg-label">
                            <mat-label>1. How would you rate your overall experience with SO Enterprise Technology? <span class="required">*</span></mat-label>
                        </span>
                        <!--star-rating [starType]="'svg'" [rating]="2.63"></star-rating-->
                        <ngb-rating class="rating"  [formControl]="feedbackForm.controls['rating'] | formControl" [max]=5>

                            <ng-template let-fill="fill" let-index="index">
                                <!--span class="star" [class.filled]="fill === 100" [class.bad]="index < 2">&#9733;</span-->
                                <span  class="star{{fill === 100 ? '-fill' : ''}}" [class.filled]="fill === 100"
                                    [class.low]="index < 0"><mat-icon>star</mat-icon></span>

                            </ng-template>

                        </ngb-rating>
                        <div class="rating-thankyou"> <span *ngIf="feedbackForm.controls['rating'].valid"> Thank you
                            for the {{feedbackForm.controls['rating'].value}} star rating.</span>
                            <mat-error *ngIf="feedbackForm.controls['rating'].invalid ">Rating is required.</mat-error>
                        </div>
                       
                        <!--div class="form-text small">
                            <div *ngIf="feedbackForm.controls['feedbackRating'].invalid" class="text-danger">Please rate
                                us</div>
                        </div-->
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <span class="rg-label">
                            <mat-label>2. Did you find the process of getting support easy and
                                straightforward?  <span class="required">*</span></mat-label>
                        </span>
                        <mat-radio-group formControlName="easeOfSupport">
                            <mat-radio-button color="primary" [value]="true">Yes</mat-radio-button>
                            <mat-radio-button color="primary" [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                        <mat-error *ngIf="feedbackForm.controls['easeOfSupport'].invalid">Please select an option.</mat-error>
 

                    </div>
                </div>
                <div class="row" *ngIf="feedbackForm.controls['easeOfSupport'].value === false">
                    <div class="col-sm-12">
                        <span class="rg-label">
                            <mat-label>2b. Please elaborate your concerns.</mat-label>
                        </span>
                        <so-textarea [formCtrl]="feedbackForm.controls['supportComments'] | formControl"
                            placeHolder="Enter your answer." label="" errormessage=""
                            [disableClearBtn]="true"></so-textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <span class="rg-label">
                            <mat-label>3. Is there something we could have done better?</mat-label>
                        </span>
                        <so-textarea [formCtrl]="feedbackForm.controls['opportunities'] | formControl"
                            placeHolder="Enter your answer." label="" errormessage="" title="x"
                            [disableClearBtn]="true"></so-textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <span class="rg-label">
                            <mat-label>4. Do you have any additional comments?</mat-label>
                        </span>
                        <so-textarea id="addcomments" [formCtrl]="feedbackForm.controls['additionalComments'] | formControl"
                            placeHolder="Enter your answer." label="" errormessage=""
                            [disableClearBtn]="true"></so-textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div><button (click)="submitForm()" type="button" [hidden]="btnSubmitHide" [disabled]="btnDisableButtons"
                                class="submit-btn" mat-raised-button color="primary"
                                matTooltip="Submit feedback" matTooltipPosition="left">
                                Submit Feedback</button></div>
                    </div>
                </div>
            </form>
  
    </mat-card-content>
</mat-card>